"use client";

import { Alert, AlertDescription } from "@universe/ui/components/alert";
import { AlertCircle } from "lucide-react";
import { useTranslations } from "next-intl";

import { AppLink } from "@/components/app-link";
import { Route } from "@/enums/route";

/**
 * Rendered at the bottom of a ledger entry detail when the BFF was unable
 * to resolve the journal-specific payload (`resolvedData === null`). The
 * surrounding detail components show whatever base ledger fields they can,
 * and append this alert so the customer has a clear recovery path.
 */
export function MissingResolutionAlert() {
  const t = useTranslations("ledger.missingResolution");

  return (
    <Alert className="mt-4" data-testid="ledger-missing-resolution-alert">
      <AlertCircle />
      <AlertDescription>
        <span>
          <span>{t("body")}</span>{" "}
          <AppLink href={Route.Support} className="underline">
            <span>{t("contactSupport")}</span>
          </AppLink>
          <span>.</span>
        </span>
      </AlertDescription>
    </Alert>
  );
}
